module.exports = __webpack_public_path__ + "img/chengben.e3340b05.svg";